import { render, staticRenderFns } from "./MyArchives.vue?vue&type=template&id=be291baa&scoped=true"
import script from "./MyArchives.vue?vue&type=script&lang=js"
export * from "./MyArchives.vue?vue&type=script&lang=js"
import style0 from "./MyArchives.vue?vue&type=style&index=0&id=be291baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be291baa",
  null
  
)

export default component.exports